import React from 'react'
import { TagMethods } from '../RadioMethodsSelection/RadioMethodsSelection.models'
import { DiyScriptMethod } from './DiyScriptMethod'
// import { GoogleTagManagerGalleryMethod } from './GoogleTagManagerGalleryMethod' // TODO: uncomment as soon as Google approves our gallery template
import { WordpressMethod } from './WordpressMethod'
import { EmailCode } from './EmailCode'
import { GoogleTagManagerWrapper } from 'Features/domainsManagement/components/GetTagModal/components/Instructions/GoogleTagManager/GoogleTagManagerWrapper/GoogleTagManagerWrapper'
import { Domain } from 'Types/Domain'

interface InstructionRendererProps {
  tagMethod: TagMethods
  tagUrl: string
  bzState?: number | null
  closeModal: () => void
  domain: Domain | undefined
}

export const InstructionRenderer = ({
  tagUrl,
  tagMethod,
  bzState,
  closeModal,
  domain,
}: InstructionRendererProps) => {
  switch (tagMethod) {
    // TODO: uncomment as soon as Google approves our gallery template
    // case 'gtmGallery':
    //   return <GoogleTagManagerGalleryMethod domainHashCode={domainHashCode} />
    case 'gtmManual':
      return <GoogleTagManagerWrapper tagUrl={tagUrl} domain={domain} />
    case 'diy':
      return <DiyScriptMethod domainHashCode={domain?.tagHashCode || ''} tagUrl={tagUrl} />
    case 'wordpress':
      return (
        <WordpressMethod
          domainHashCode={domain?.tagHashCode || ''}
          bzState={bzState}
          domainAddress={domain?.address || ''}
        />
      )
    case 'googleIntegration': // To be implemented
    case 'emailDev':
      return <EmailCode domainId={domain?.id || 0} closeModal={closeModal} />
    default:
      return <DiyScriptMethod domainHashCode={domain?.tagHashCode || ''} tagUrl={tagUrl} />
  }
}
